import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { getSearchFilters } from "../../api/search/search";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { SSearchFilters } from "../../styles/StyledSearchFilters";
import { SearchFiltersList } from "./SearchFiltersList";

type SearchFilterDataType = {
	id: number;
	name: string;
};

export type SearchFiltersDataType = {
	[key: string]: SearchFilterDataType[];
};

export type SearchFilterType = {
	name: string;
	options: SearchFilterDataType[];
};

type SearchFiltersProps = {
	/** Filter groups side by side, for use in the page content instead of the sidebar */
	inline?: boolean;
};

export const SearchFilters = ({ inline = false }: SearchFiltersProps) => {
	const { t } = useTranslation();

	const { axiosPrivate } = useAxiosPrivate();

	const { isLoading, data } = useQuery<SearchFiltersDataType>("searchFilters", () => getSearchFilters(axiosPrivate));
	const searchFilters: SearchFilterType[] =
	!isLoading && data
		? Object.keys(data).map((item) => {
				const options = Array.isArray(data[item]) ? data[item] : [];
				return {
					name: item,
					options,
				};
		  })
		: [];

	if (isLoading) return <></>;

	return (
		<SSearchFilters className={inline ? "inline" : undefined}>
			{inline ? <h5>{t("filters")}</h5> : <h3>{t("filters")}</h3>}
			<SearchFiltersList filters={searchFilters} />
		</SSearchFilters>
	);
};
